import { defineNuxtPlugin, useRuntimeConfig, useHead, useRoute } from "#imports";

export default defineNuxtPlugin((nuxtApp) => {
	const appEnv = useRuntimeConfig().public.appEnv;
	if(appEnv === "prod"){
		if (process.client) {
			//const runtimeConfig = useRuntimeConfig();
			//const appEnv = runtimeConfig.appEnv;
			const ignoreRoutes = ['/widget/instituicao','/widget/allinstitutions','/lp/anima','/lp/fmu'];
			//inversão temporaria para acompanha a anima
			const route = useRoute()
			//const enabledRoutes = ['/lp/fmu','/lp/anima','/'];// '/lp/anima'
			const keys: any = {
				'default':'2835070',
				'/lp/fmu': '3555767',
			}

			const key = (Object.keys(keys).includes(route.path)) ? keys[route.path] : keys['default'];

			if (!ignoreRoutes.includes(route.path)) {
				// useHead(
				// 	{
				// 		script: [
				// 			{
				// 				hid: 'hotjar',
				// 				children: `
				// 					(function(h,o,t,j,a,r){
				// 						h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
				// 						h._hjSettings={hjid:${key},hjsv:6};
				// 						a=o.getElementsByTagName('head')[0];
				// 						r=o.createElement('script');r.async=1;
				// 						r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
				// 						a.appendChild(r);
				// 					})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
				// 				`,
				// 			}
				// 		]
				// 	}
				// );
			}
		}
	}
});
